<app-appHeader></app-appHeader>
<div class="bg-blue-50 px-4 py-2 rounded-md mb-4 flex mt-[75px]">
  <mat-icon class="mr-[10px] !w-[26px]">info</mat-icon>
  <p class="text-[#868E96] text-[1rem]">
    You are currently viewing a yest project.This is intended for learning purpose so you can get to know BuildXY
  </p>
</div>
<div class=" mx-auto py-4 px-[50px]">
  <div>
 
  
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
  <!-- Drawings  -->
          <div class=" border-r pr-4" style=" grid-template-columns: 20vw auto auto; !important">
              <div class="flex justify-between items-center mb-4">
                <div class="text-gray-700 text-sm">
                  {{ confirmedCount }} of {{ totalDocuments }} Confirmed
                </div>
                <button (click)="confirmAll()" class="bg-gray-200 text-gray-700 text-sm px-2 py-1 rounded">
                  Confirm All
                </button>
              </div>
          <div class="flex table-scroll">
              
            
                <ul class="text-gray-700 text-sm">
                  <li *ngFor="let doc of documents" class="mb-2">
                    <div class="flex justify-between items-center">
                      <div class="font-bold">{{ doc.id }}</div>
                      <div *ngIf="doc.status" class="text-gray-500">{{ doc.status }}</div>
                    </div>
                    <div class="text-gray-500">{{ doc.category }}</div>
                  </li>
                </ul>
              </div>
            </div>
<!-- Typical Details -->
        <div class="flex-1 border border-[#A9A9A9] p-4 mb-4 md:mb-0 md:mr-4 max-h-[73vh]">
          <div class="border border-[#000000] h-[55vh] max-h-[55vh] mb-4"></div>
          <p class="text-center text-[#343A40] font-semibold">TYPICAL DETAILS</p>
          <p class="text-end text-2xl !text-[#343A40] font-bold mt-2">S003</p>
        </div>
<!-- General Information -->
        <div class="">
          <h2 class="!text-[1rem] !font-semibold mb-4">GENERAL INFORMATION</h2>
          
          <form [formGroup]="drawingForm">
            <div class="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label class="block text-[1rem] font-semibold text-[#343A40]">Drawing Number</label>
                <input type="text" formControlName="number" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2">
              </div>
              <div>
                <label class="block text-[1rem] font-semibold text-[#343A40]">Discipline</label>
                <input type="text" formControlName="discipline" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2">
              </div>
            </div>
        
            <div class="mb-4">
              <label class="block text-[1rem] font-semibold text-[#343A40]">Drawing Title</label>
              <input type="text" formControlName="title" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2">
            </div>
          </form>
        
          <h2 class="block !text-[1rem] !font-semibold !text-[#343A40] !m-0">VERSIONS</h2>
          <p class="text-sm text-gray-500 mb-4">To record versions, update the drawing Date or Drag and Drop the row</p>
          
          <table class="min-w-full bg-[#FAFAFA] border border-gray-300">
            <thead>
              <tr>
                <th class="px-[0.5rem] py-2 text-[1rem] font-normal  border-b">Revision</th>
                <th class="px-[0.5rem] py-2 text-[1rem] font-normal border-b">Drawing Date</th>
                <th class="px-[0.5rem] py-2 text-[1rem] font-normal border-b">Received Date</th>
                <th class="px-[0.5rem] py-2 text-[1rem] font-normal border-b">Drawing Set</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let version of versions.value.rows; let i = index">
                <td class="px-[0.5rem] text-center py-2 border-b">
                  {{version.revision}}
                </td>
                <td class="px-[0.5rem] text-center py-2 border-b">
                  {{version.drawingDate}}
                </td>
                <td class="px-[0.5rem] text-center py-2 border-b">
                 {{version.receivedDate}}
                </td>
                <td class="px-[0.5rem] text-center py-2 border-b">
                  {{version.set}}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="flex justify-end mt-6">
              <button  class="bg-[#F1F3F5] !text-[1rem] !font-medium text-[#E76B3F] border border-[#E76B3F] px-[20px] py-[10px] rounded-md mr-2">Delete</button>
              <button (click)="confirmationDialog()" class="!bg-[#E76B3F] !text-[1rem] !font-medium !text-[#F1F3F5] px-[20px] py-[10px] rounded-[4px]" >Confirm</button>
            </div>
        </div>
      </div>
     
  </div>
</div>